/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/**
 * Mocks html parsing since the dependency is quite large.
 * @param {string} str HTML string.
 */
export default function mockHtmlParser(str) {
  if (process.env.NODE_ENV !== 'production') {
    console.warn('HTML parsing currently unsupported in i18n'); // eslint-disable-line no-console
  }
  return str;
}
